export type PricingBand = {
  min: number;
  max: number | null;
  label: string;
  monthlyPrice: number | null;
};

/**
 * Evaluated internal pricing model. The array is intentionally the single
 * edit point for future band/price refinements.
 */
export const PRICING_BANDS: readonly PricingBand[] = [
  { min: 0, max: 9_999, label: "Under $10K", monthlyPrice: 299 },
  { min: 10_000, max: 24_999, label: "$10K – $25K", monthlyPrice: 399 },
  { min: 25_000, max: 49_999, label: "$25K – $50K", monthlyPrice: 499 },
  { min: 50_000, max: 74_999, label: "$50K – $75K", monthlyPrice: 599 },
  { min: 75_000, max: 99_999, label: "$75K – $100K", monthlyPrice: 699 },
  { min: 100_000, max: 199_999, label: "$100K – $200K", monthlyPrice: 799 },
  { min: 200_000, max: 299_999, label: "$200K – $300K", monthlyPrice: 899 },
  { min: 300_000, max: null, label: "$300K+", monthlyPrice: null },
];

export function getPricingBand(monthlyExpenses: number): PricingBand {
  const normalized = Math.max(0, Math.round(monthlyExpenses));
  return PRICING_BANDS.find((band) => band.max === null || normalized <= band.max) ?? PRICING_BANDS[PRICING_BANDS.length - 1]!;
}

export function getAnnualReference(monthlyPrice: number): number {
  return monthlyPrice * 10;
}

export function formatCurrency(amount: number): string {
  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    maximumFractionDigits: 0,
  }).format(amount);
}
